/* MAISON ROTEA - GLOBAL SCROLL REVEAL V1 */
(() => {
  "use strict";

  const motion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  );

  if (motion.matches || !("IntersectionObserver" in window)) {
    return;
  }

  const selector = [
    ".title-wrapper-with-link",
    ".rich-text__blocks",
    ".image-with-text__media",
    ".image-with-text__content",
    ".multicolumn-list__item",
    ".collection-list__item",
    ".product-grid > .grid__item",
    ".grid--peek > .grid__item",
    ".card-wrapper",
    ".rotea-trust__item",
    ".collage__item",
    ".banner__content",
    ".newsletter__wrapper",
    ".featured-collection__title",
    "h2.section-heading"
  ].join(",");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;

      target.setAttribute("data-rotea-reveal", "visible");
      observer.unobserve(target);
    });
  }, {
    threshold: 0.08,
    rootMargin: "0px 0px -25px 0px"
  });

  function eligible(element) {
    if (element.hasAttribute("data-rotea-reveal")) return false;
    if (element.closest("header, footer, nav, dialog")) return false;
    if (element.closest("[hidden], [aria-hidden='true']")) return false;
    if (element.closest(".product-form, .shopify-payment-button")) {
      return false;
    }

    const section = element.closest(".shopify-section");
    if (!section || !section.closest("main")) return false;

    const sectionName = (
      section.id + " " + section.className
    ).toLowerCase();

    if (/header|footer|announcement|cart-drawer|cookie|age-gate/.test(
      sectionName
    )) return false;

    // Ne pas animer toute la zone d'achat de la PDP.
    if (/main-product|jibril-main-product|pdp-main-product/.test(
      sectionName
    )) return false;

    if (element.getClientRects().length === 0) return false;

    return true;
  }

  function scan() {
    const main = document.querySelector("main");
    if (!main) return;

    main.querySelectorAll(".shopify-section").forEach((section) => {
      const selected = [];

      section.querySelectorAll(selector).forEach((element) => {
        if (!eligible(element)) return;

        // Évite d'animer simultanément un parent et son enfant.
        if (selected.some(parent => parent.contains(element))) return;
        if (selected.length >= 24) return;

        selected.push(element);
      });

      selected.forEach((element, index) => {
        element.style.setProperty(
          "--rotea-reveal-delay",
          `${Math.min(index % 5, 4) * 65}ms`
        );

        element.setAttribute("data-rotea-reveal", "pending");
        observer.observe(element);
      });
    });
  }

  let scheduled = false;

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      scan();
    });
  }

  function init() {
    scan();

    const main = document.querySelector("main");

    if (main) {
      const mutations = new MutationObserver(scheduleScan);

      mutations.observe(main, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener(
      "shopify:section:load",
      scheduleScan
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, {
      once: true
    });
  } else {
    init();
  }
})();
